export const promo = [
    {
        id: "1",
        name: "Promotii",
        path: "/Promotii",
        cName: "submenu-promo-item"
    },
    {
        id: "2",
        name: "Abonamente",
        path: "/Abonamente",
        cName: "submenu-promo-item"
    },
    {
        id: "3",
        name: "Flori de sezon",
        path: "/Flori-de-sezon",
        cName: "submenu-promo-item"
    },
    {
        id: "4",
        name: "Coroane Funerare",
        path: "/Coroane-Funerare",
        cName: "submenu-promo-item"
    },
]